import { useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import { getQueryParam } from 'featureSliced/shared/utils/getQueryParam'
import moment from 'moment'
import { handleLocalStorage } from 'featureSliced/shared/utils/handleLocalStorage'
import { replayInstance } from 'featureSliced/shared/utils/sentry'
import * as Sentry from '@sentry/react'

const ROUTES_TO_TRACK = ['/checkout', '/payment']

export const SentryReplay = () => {
  const location = useLocation()

  useEffect(() => {
    const datatransTrxId = getQueryParam('datatransTrxId')
    const orderGuid = getQueryParam('orderGuid')

    const isProd = process.env.REACT_APP_IS_PROD === '0'
    const isCorrectLocation = ROUTES_TO_TRACK.includes(location.pathname)
    const isCorrectParams = !!datatransTrxId?.length || !!orderGuid?.length

    try {
      if (isProd && (isCorrectLocation || isCorrectParams)) {
        replayInstance?.start()
        console.log(' Sentry recording started')

        const { guid, dataEnc } = handleLocalStorage(['guid', 'dataEnc'])
        Sentry.setContext('sessionData', {
          guid,
          dataEnc,
          date: moment().format('YYYY-MM-DD'),
          time: moment().format('HH:mm'),
        })
      } else {
        replayInstance?.stop()
        console.log(' Sentry recording stopped')
      }
    } catch (e) {
      console.log('Sentry failed to start!', e)
    }
  }, [location])

  return null
}
